import { ROUTES } from 'utils/constants';

export const CTA_AS_FIGURE = [ROUTES.webinarLLM.slug, ROUTES.webinarDeployingAgent.slug];
